var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.textHeader)?_c('div',{staticClass:"ml-4 mb-n2 heading font-weight-bold header-decoration"},[_vm._v(" "+_vm._s(_vm.textHeader)+" ")]):_vm._e(),_c('os-input-checkbox-group',{attrs:{"items":_vm.checkBoxItems,"readonly":_vm.readonly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }